import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { TopicCard } from "@/components/TopicCard";
import { Bookmark, Loader2 } from "lucide-react";
import { logError } from "@/lib/logger";

export default function Bookmarks() {
  const { user, checked } = useAuth();
  const navigate = useNavigate();
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (checked && !user) {
      navigate("/login");
      return;
    }
    if (!user) return;
    (async () => {
      setLoading(true);
      try {
        const { data } = await api.get("/bookmarks");
        setTopics(data);
      } catch (err) {
        logError("Failed to load bookmarks:", err);
      }
      setLoading(false);
    })();
  }, [user, checked, navigate]);

  let content;
  if (loading) {
    content = (
      <div className="flex justify-center py-24">
        <Loader2 className="h-7 w-7 animate-spin text-[#D92D20]" />
      </div>
    );
  } else if (topics.length === 0) {
    content = (
      <div className="py-24 text-center">
        <p className="font-heading text-2xl text-white">Nothing saved yet.</p>
        <p className="meta-label mt-3 text-[#737373]">Open a dossier and hit "Save" to build your collection.</p>
      </div>
    );
  } else {
    content = (
      <div className="grid auto-rows-[minmax(220px,auto)] grid-cols-1 gap-4 md:grid-cols-3">
        {topics.map((t, i) => (
          <TopicCard key={t.id} topic={t} index={i} />
        ))}
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-7xl px-6 py-12">
      <div className="mb-10 flex items-center gap-3 border-b border-[#333] pb-6">
        <Bookmark className="h-6 w-6 text-[#FBBF24]" strokeWidth={1.5} />
        <div>
          <h1 className="font-heading text-3xl tracking-tight text-white">Your Saved Dossiers</h1>
          <div className="meta-label mt-1 text-[#737373]">Private archive</div>
        </div>
      </div>

      {content}
    </div>
  );
}
